import React, { useEffect, useRef } from "react";
import { ScrollArea } from "../ui/scroll-area";
import { Search } from "lucide-react";

const ItemSidebar = ({
  items,
  selectedItem,
  searchTerm,
  onSearchChange,
  onItemClick,
  itemLabel,
}) => {
  const selectedItemRef = useRef(null);

  // Scroll to selected item when selection changes
  useEffect(() => {
    if (selectedItem && selectedItemRef.current) {
      // Small delay to ensure DOM is updated after selection
      setTimeout(() => {
        const selectedElement = selectedItemRef.current;

        if (!selectedElement) return;

        // Use scrollIntoView for simpler, more reliable scrolling
        selectedElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }, 50);
    }
  }, [selectedItem?.id, selectedItem?.name]); // Trigger when ID changes OR name changes

  return (
    <div className="col-span-1 flex flex-col min-h-0">
      <div className="flex mb-4 w-full max-w-md">
        <input
          type="text"
          placeholder={`search ${itemLabel.toLowerCase()}`}
          className="flex-1 rounded-r-none bg-customGrey pl-4 w-full !h-8 placeholder:text-black placeholder:text-center focus:!h-8 focus:!outline-none"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <button
          type="button"
          className="bg-customBlue h-8 w-8 pl-0 hover:bg-customBlue/90 border-gray-300 flex justify-center items-center"
        >
          <Search className="w-4 h-4 text-white" />
        </button>
      </div>

      <ScrollArea className="divide-y divide-blue-500 border-b border-blue-500 h-full">
        <ul className="text-sm text-gray-800">
          {items
            ?.sort((a, b) => a.name.localeCompare(b.name))
            ?.map((item) => {
              const isSelected = String(selectedItem?.id) === String(item.id);
              return (
                <li key={item.id || item.name}>
                  <div
                    ref={isSelected ? selectedItemRef : null}
                    onClick={() => onItemClick(item)}
                    className={`
                      p-2 cursor-pointer transition-colors border-t border-blue-500 text-left flex items-center
                      ${
                        isSelected
                          ? "bg-blue-100 font-bold text-black"
                          : "hover:bg-blue-100"
                      }
                    `}
                  >
                    {item.name}
                  </div>
                </li>
              );
            })}
        </ul>
      </ScrollArea>
    </div>
  );
};

export default ItemSidebar;
